import { mergeStyleSets } from '@fluentui/react';
import { isExternalApp } from '../../utils/costants';

export interface IComponentClassNames {
    logo: string,
    icon: string,
    icon2: string,
    rootHovered: string,
    root: string,
    questionMark: string,
    root2: string,
}
  
export const getClassNames = (): IComponentClassNames => {
    return mergeStyleSets({
        logo: {
            display: 'flex',
            alignItems: 'center'
        },
        icon: {
            color: 'white',
           
        },
        icon2: {
            color: (!isExternalApp) ? '#30627B' : '#BF624A',
        },
        questionMark: {
            color: 'white',
            fontSize: 22,
            marginBottom: 2
        },
        root: {
            height: 48,
            width: 48,
            marginTop: 4
        },
        rootHovered: {
            backgroundColor: (!isExternalApp) ? '#30627B' : '#BF624A' 
        },
        root2: {
            height: 48,
            width: 48,
            backgroundColor: 'white',
        }
    });
};